import { useEffect, useState } from 'react';
export function usePluginRevision(): number {
  const [revision, setRevision] = useState(0);
  useEffect(() => {
    const changed = () => setRevision((value) => value + 1);
    window.addEventListener('crowdex-plugins-changed', changed);
    window.addEventListener('crowdex-plugin-inventory-updated', changed);
    return () => {
      window.removeEventListener('crowdex-plugins-changed', changed);
      window.removeEventListener('crowdex-plugin-inventory-updated', changed);
    };
  }, []);
  return revision;
}
